// import { RoomProps, TrackProps } from '../../mocks/roomMock'

import { Room, RemoteTrackPublication, LocalTrackPublication } from 'twilio-video'

/**
 * getTwilioTracks - Returns the Twilio tracks for the presenter
 * @param room The Twilio Room object
 * @param presenterSid A string representing the presenter's SID
 * @return The Twilio Tracks map
 */

export default function (room: Room, presenterSid: string): Map<string, LocalTrackPublication | RemoteTrackPublication> {

  if (!room) return new Map()

  if (Reflect.has(room, 'localParticipant') && room.localParticipant.sid === presenterSid) {

    return room.localParticipant.tracks

  }

  for (const [curPresenterSid, values] of room.participants.entries()) {

    if (curPresenterSid === presenterSid) return values.tracks

  }

  return new Map()

}
